import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from '../ui/button';
import { footerLinks } from '../../data/mock';

export const ContactCTA = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  const whatsappNumber = footerLinks.contact.whatsapp.replace(/\D/g, '');
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
    "Hi! I'm interested in your services."
  )}`;

  return (
    <section ref={ref} className="relative overflow-hidden py-20 sm:py-24 lg:py-32">
      <div className="absolute inset-0 bg-[var(--bg-soft)]" />

      <div className="relative w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="relative overflow-hidden rounded-2xl sm:rounded-3xl border border-blue-500/20 p-6 sm:p-10 md:p-12 lg:p-20"
        >
          <div className="absolute inset-0 bg-[var(--card-color)]" />
          <div className="pointer-events-none absolute top-0 right-0 w-[220px] h-[220px] sm:w-80 sm:h-80 lg:w-96 lg:h-96 bg-blue-600/10 rounded-full blur-[80px] sm:blur-[100px]" />
          <div className="pointer-events-none absolute bottom-0 left-0 w-[180px] h-[180px] sm:w-64 sm:h-64 lg:w-72 lg:h-72 bg-blue-500/5 rounded-full blur-[70px] sm:blur-[80px]" />

          <div className="relative flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8 sm:gap-10">
            <div className="max-w-xl min-w-0">
              <h2 className="text-[2rem] sm:text-4xl lg:text-5xl font-bold font-['Syne'] text-[var(--text-primary)] mb-4 sm:mb-5 leading-tight break-words">
                Ready to Transform
                <br />
                Your Digital Presence?
              </h2>

              <p className="text-[var(--text-muted)] text-base sm:text-lg leading-relaxed">
                Let&apos;s discuss your project and explore how we can help your
                business grow. Book a free consultation with our team today.
              </p>
            </div>

            <div className="flex w-full lg:w-auto flex-col sm:flex-row gap-3 sm:gap-4">
              <Link to="/contact" className="w-full sm:w-auto">
                <Button className="w-full sm:w-auto bg-blue-600 hover:bg-blue-500 text-white font-semibold px-6 sm:px-8 py-5 sm:py-6 rounded-xl text-sm sm:text-base transition-all duration-300 hover:shadow-lg hover:shadow-blue-600/20 whitespace-nowrap">
                  Get Free Consultation
                  <ArrowRight className="w-5 h-5 ml-2" />
                </Button>
              </Link>

              <a
                href={whatsappUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="w-full sm:w-auto"
              >
                <Button
                  variant="outline"
                  className="w-full sm:w-auto border-[var(--border-color)] text-[var(--text-secondary)] hover:text-[var(--text-primary)] hover:border-slate-500 hover:bg-black/5 dark:hover:bg-white/5 font-semibold px-6 sm:px-8 py-5 sm:py-6 rounded-xl text-sm sm:text-base transition-all duration-300 whitespace-nowrap"
                >
                  Chat on WhatsApp
                </Button>
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};